import { render, staticRenderFns } from "./CategoryManagerView.vue?vue&type=template&id=3282e8fe&scoped=true"
import script from "./CategoryManagerView.vue?vue&type=script&lang=js"
export * from "./CategoryManagerView.vue?vue&type=script&lang=js"
import style0 from "./CategoryManagerView.vue?vue&type=style&index=0&id=3282e8fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3282e8fe",
  null
  
)

export default component.exports